module.exports = __webpack_public_path__ + "img/Lukasz_Kidzinski.e1f3aa21.jpg";